
const triggerFinanceWebhook = async (bookingId) => {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", "e5362baf-c777-4d57-a609-6eaf1f9e87f6");

  const formdata = new FormData();
  formdata.append("Booking_id", bookingId);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
    mode: 'no-cors', // This will prevent CORS errors but you won't get response data
  };

  try {
    const response = await fetch(
      `${process.env.REACT_APP_N8N_WEBHOOK_BASE_URL}/FinopsRequestTriggerV1`,
      requestOptions
    );
    // Note: With 'no-cors' mode, response will be opaque and you can't read the result
    console.log("Finance Webhook triggered successfully");
  } catch (error) {
    console.error("Finance Webhook Error:", error);
    // Don't throw error - fail silently to not disrupt user experience
  }
};

export default triggerFinanceWebhook;
